
import { defineComponent, ref } from 'vue';

import { useUserStore } from '@/store/modules/user';

import SystemIntroductBox from './components/SystemIntroductBox/index.vue';
import { FILESERVICE } from '@/config/defaultSetting';
import WMSClientDialog from '@/components/WMSClientDialog/index.vue';

interface IhoverContentType {
  hoverIcon: string;
  hoverName: string;
}
export interface ItemBoxDataType {
  icon: string;
  name: string;
  description: string;
  applicationCode?: string;
  hoverContent: IhoverContentType[];
  onClickHandle?: () => void;
}
export default defineComponent({
  name: 'Home',
  components: {
    SystemIntroductBox,
    WMSClientDialog,
  },

  setup() {
    const userStore = useUserStore();
    const dialogVisible = ref<boolean>(false);

    const isShowFristTabState = ref(true);
    const Showing = ref(true);

    const systemIntroductBoxData = ref([
      {
        icon: 'ods',
        name: 'ODS',
        description: '智能路由适配，最佳订单履约路径推荐',
        applicationCode: 'Ods',
        onClickHandle: () => {
          openSystemByCode('ODS');
        },
        hoverContent: [
          {
            hoverIcon: 'workbench',
            hoverName: '工作台',
          },
          {
            hoverIcon: 'Ordermanagement',
            hoverName: '订单管理',
          },
          {
            hoverIcon: 'Deliveryplan',
            hoverName: '发货计划',
          },
          {
            hoverIcon: 'Inventorycenter',
            hoverName: '库存中心',
          },
          {
            hoverIcon: 'ExpressPlatform',
            hoverName: '快递平台',
          },
          {
            hoverIcon: 'Policyconfiguration',
            hoverName: '策略配置',
          },
        ],
      },
      {
        icon: 'wms',
        name: 'WMS',
        description:
          '精细化库存管理、智能波次和库内策略、PDA作业标准化，提升仓储运转效率',
        onClickHandle: () => {
          openWMSClient();
        },
        hoverContent: [
          {
            hoverIcon: 'warehousingmanagement',
            hoverName: '入库管理',
          },
          {
            hoverIcon: 'Inventorymanagement',
            hoverName: '库存管理',
          },
          {
            hoverIcon: 'Outboundmanagement',
            hoverName: '出库管理',
          },
          {
            hoverIcon: 'PADadministration',
            hoverName: 'PAD管理',
          },
          {
            hoverIcon: 'Barcodemanagement',
            hoverName: '条码管理',
          },
          {
            hoverIcon: 'strategy',
            hoverName: '策略管理',
          },
        ],
      },
      {
        icon: 'TMS',
        name: 'TMS',
        applicationCode: 'TMS',
        description: '运输全程透明、可视。物流协同驱动，提升流通速率',
        onClickHandle: () => {
          openSystemByCode('TMS');
        },
        hoverContent: [
          {
            hoverIcon: 'workbench',
            hoverName: '工作台',
          },
          {
            hoverIcon: 'transportationManagement',
            hoverName: '运输管理',
          },
          {
            hoverIcon: 'Aftersalesmanagement',
            hoverName: '售后管理',
          },
          {
            hoverIcon: 'Billingmanagement',
            hoverName: '计费管理',
          },
          {
            hoverIcon: 'resourcemanagement',
            hoverName: '资源管理',
          },
          {
            hoverIcon: 'statisticalanalysis',
            hoverName: '统计分析',
          },
        ],
      },
      {
        icon: 'CSP',
        name: 'CSP',
        applicationCode: 'CSP',
        description:
          '签约入驻、任务领派、预约送装、签收核销、售后一站式末端服务平台',
        onClickHandle: () => {
          openSystemByCode('CSP');
        },
        href: '',
        hoverContent: [
          {
            hoverIcon: 'taskmanagement',
            hoverName: '任务管理',
          },
          {
            hoverIcon: 'Signinmanagement',
            hoverName: '签收管理',
          },
          {
            hoverIcon: 'Masterclassroom',
            hoverName: '师傅课堂',
          },
          {
            hoverIcon: 'Capabilitymanagement',
            hoverName: '能力管理',
          },
        ],
      },
    ]);
    async function openWMSClient() {
      dialogVisible.value = true;
    }
    function openSystemByCode(code: string) {
      let targetUrl: string | undefined = '';
      switch (code) {
        case 'TMS':
          targetUrl = process.env.VUE_APP_TMS_SERVERS_URL;
          break;
        case 'BMS':
          targetUrl = process.env.VUE_APP_BMS_SERVERS_URL;
          break;
        case 'PMS':
          targetUrl = process.env.VUE_APP_PMS_SERVERS_URL;
          break;
        case 'ODS':
          targetUrl = process.env.VUE_APP_ODS_SERVERS_URL;
          break;
        case 'CSP':
          targetUrl = process.env.VUE_APP_CSP_SERVERS_URL;
          break;
        default:
          return;
      }
      targetUrl && window.open(targetUrl, '_blank');
    }
    function onDialogClose() {
      dialogVisible.value = false;
    }
    function changeShowFirstTab(value: boolean) {
      isShowFristTabState.value = value;
    }
    function changeShowing(value: boolean) {
      Showing.value = value;
    }

    return {
      FILESERVICE,
      userStore,
      dialogVisible,
      openSystemByCode,
      openWMSClient,
      onDialogClose,
      systemIntroductBoxData,
      isShowFristTabState,
      Showing,
      changeShowFirstTab,
      changeShowing,
    };
  },
});
